import logo from './logo.svg';
import './App.css';
import Guide from './components/Guide'
import GuideRouter from './Router'
import { Provider } from 'react-redux';
import store from './store/index'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {
  return (
    <Provider store={store}>
    <Router>
    <Guide />
    </Router>
    </Provider>
  );
}

export default App;
